import React from "react";

import { DetailDisplay } from "widgets";
import { VERTICAL_NAME } from "constants/constants";

import styles from "./MultipleUsers.module.scss";

const MultipleUsers = (props) => {
  const { customerDetails, handleOnSelectUser } = props;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        Multiple accounts found against the entered phone number. Please choose
        an account to create order.
      </div>
      <div className={styles.scrollRegion}>
        <div className={styles.list}>
          {customerDetails &&
            customerDetails.map((customer) => (
              <div
                className={styles.userInfoCard}
                key={customer.uamId}
                role="button"
                tabIndex={0}
                onClick={() => handleOnSelectUser(customer.uamId)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleOnSelectUser(customer.uamId);
                  }
                }}
              >
                <DetailDisplay
                  layout="row"
                  title="Name"
                  value={
                    !(customer.firstName || customer.lastName)
                      ? "NA"
                      : customer.firstName + " " + customer.lastName
                  }
                />
                <DetailDisplay
                  layout="row"
                  title="User Id"
                  value={customer.uamId}
                />
                <DetailDisplay
                  layout="row"
                  title="Business Vertical"
                  value={VERTICAL_NAME[customer.verticalId]}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default MultipleUsers;
